import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import type { IMessagingService } from '@breath-lab/services';
import { firebaseApp } from '../firebase/firebaseConfig';

const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY as string;

export class WebMessagingService implements IMessagingService {
  isSupported(): Promise<boolean> {
    return isSupported();
  }

  async requestPermissionAndGetToken(): Promise<string | null> {
    // Dispatch requestPermission() synchronously (before any await) so the
    // user-gesture token from the originating click is preserved. Browsers
    // that strip transient activation across microtask boundaries silently
    // resolve to 'default' without prompting otherwise.
    const permissionPromise = Notification.requestPermission();
    const supported = await this.isSupported();
    if (!supported) return null;

    const permission = await permissionPromise;
    if (permission !== 'granted') return null;

    await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    const registration = await navigator.serviceWorker.ready;
    const messaging = getMessaging(firebaseApp);
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    return token || null;
  }
}
